if (process.env.NODE_ENV === 'production') {
  module.exports = require('./panel.production.js');
} else {
  module.exports = require('./panel.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/panel/dist/es/panel.js
// module id = 1375
// module chunks = 0